import React, { useState } from 'react';
import MaterialCard from './MaterialCard';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';

export default function TabFiles({ currentModule }) {
  const [searchTerm, setSearchTerm] = useState('');

  const moduleLessons = currentModule?.['learning-system-contents']
    ?.map(content =>
      content.learning_system_items.map(item => {
        return item;
      })
    )
    .flat();

  const filteredFiles = currentModule?.['learning-system-files']?.filter(file => {
    if (searchTerm == '') {
      return file;
    }
    if (file.title !== null && file.title.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
      return file;
    }
  });

  return (
    <div className="animate-fade-in">
      <div className="filter-bar">
        <div className="filter-bar__row">
          <label
            htmlFor="search"
            className="filter-bar__label"
          >
            {t('textsCommon.search')}
          </label>
          <input
            className="form__control form__control--search-with-icon"
            placeholder={t('filter.labelSearchFiles')}
            type="search"
            name="search"
            id="search"
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredFiles && filteredFiles?.length > 0 ? (
        <div className="round-dg-wrapper">
          <table
            className="round-dg round-dg--light"
            style={{ minWidth: '770px' }}
          >
            <thead className="round-dg__header">
              <tr className="round-dg__row">
                <th className="round-dg__cell-header round-dg__cell-header--sm">Nome do material</th>
                <th className="round-dg__cell-header round-dg__cell-header--sm"></th>
                <th className="round-dg__cell-header">Aula</th>
              </tr>
            </thead>
            <tbody className="round-dg__body">
              {filteredFiles?.map(material => {
                return (
                  <MaterialCard
                    material={material}
                    moduleLessons={moduleLessons}
                    currentModule={currentModule}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState type="data" />
      )}
    </div>
  );
}
